<template>
    <div>
        <v-progress-linear
            indeterminate
            color="indigo"
            height="10"
            top
            :active="loaded"
        ></v-progress-linear>
        <v-snackbar v-model="snackbar" :color="color" top :timeout="5000">
          <v-row justify="space-between">
            {{ text }}
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
        <v-overlay :value="showOverlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-container v-if="loaded === false && flight === null">
           <v-row justify='center' class="pt-5 mt-5"><p class="display-1 primary--text">This flight is not available, please seach again in few minutes.</p></v-row>
        </v-container>
        <v-container style="height: 95vh;" fluid v-if="loaded === false && flight !== null">
            <v-row v-if="flight !== null">
                <v-col cols="12" style="padding: 0px;">
                  <vue-good-wizard
                  :steps="steps"
                  :onNext="nextClicked"
                  :onBack="backClicked"
                  color="indigo"
                  finalStepLabel="Finish"
                  :nextStepLabel="nextLabel"
                  ref="myWizard"
                  >
                    <div slot="page1" color="indigo">
                      <v-row>
                        <v-col cols="12">
                          <flight-card :flights="flightCard"/>
                        </v-col>
                        <v-col cols="12">
                          <v-card outlined class="elevation-0 pa-5">
                            <v-card-title class="primary--text font-weight-bold">Pricing summary</v-card-title>
                            <v-card-text>
                              <p v-for="(item, i) in flight.pricingInfo.breakDowns" :key="i" class="body-1 primary--text mb-0">
                                {{item.passengerQuantity}}
                                <template v-for="type in types">
                                  <span :key="type.code" v-if="type.code === item.passengerType">{{type.label}}</span>
                                </template>(s) basic fare <strong>{{flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode}} {{item.baseFare}}</strong> with <strong>{{flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode}} {{item.taxes}}</strong> taxes  for person ><strong>Total {{item.TotalFare_CurrencyCode === 'USD' ? '$' : item.TotalFare_CurrencyCode}} {{item.totalFare}}</strong>
                              </p>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols=12 >
                          <v-card outlined class="elevation-0 pa-5">
                            <v-card-title class="primary--text font-weight-bold">Flight Rules</v-card-title>
                            <v-card-text>
                              <ul>
                                <li v-for="rule in flight.rules" :key="rule"> {{ rule }}</li>
                              </ul>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- <div slot="page2" >
                      <v-row class="d-flex flex-column align-center justify-center mt-5">
                        <h3 class="text-uppercase indigo--text">Choose your seat</h3>
                        <p class="caption">Select a seat (or skip to let us assign one)</p>
                        <v-tabs
                          v-model="tab"
                          background-color="transparent"
                          color="indigo"
                          grow
                        >
                      <v-tab
                        v-for="(item,index) in flight.flightSegments"
                        :key="item"
                        @click="getSeatMap(index)"
                      >
                        segment{{ index+1 }}
                      </v-tab>
                    </v-tabs>

                      </v-row>
                      <v-container v-if="seats" class="mt-5">
                        <v-row class="mb-n6 ml-n5" align="center" justify="center" style="width:75%">
                          <v-col cols="1"></v-col>
                          <v-col v-for="(colWidth,start) in layout" :key="colWidth" :cols="colWidth">
                            <div class="d-flex mb-n7">
                              <p
                                class="font-weight-bold black--text mr-8"
                                v-for="name in reshapeSeatNumber(start)"
                                :key="name"
                              >
                                {{ name }}
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row v-for="(row, rowIndex) in seats" :key="rowIndex" align=center >
                          <v-col cols="1" class="mr-n5"><p class="font-weight-bold black--text"> {{ row.rowNumber }}</p></v-col>
                          <v-col
                            v-for="(segmentSize, segIndex) in layout"
                            :key="segIndex"
                            :cols="segmentSize"
                          >
                            <v-menu
                              v-for="seat in reshapeSeatMap(row.seats, segIndex)"
                              :key="seat.seatNumber"
                              open-on-hover
                              top
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  fab
                                  :color="seat.status === 'available' ? 'blue' : 'grey'"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="white">{{ seat.status === 'available' ? 'mdi-seat' : 'mdi-cancel' }}</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-icon>mdi-ticket-confirmation</v-icon>
                                  Seat:{{ seat.seatNumber }}</v-list-item>
                                <v-list-item>
                                  <v-icon>mdi-cash</v-icon>
                                  Price:{{ seat?.price }}</v-list-item>
                                <v-list-item>
                                  <v-icon>mdi-seat</v-icon>
                                  Type:{{ seat.type }}</v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                      </v-row>
                      </v-container>
                    </div> -->
                    <div slot="page2">
                      <v-row>
                        <v-form v-model="valid1" ref="form1">
                        <p class="body-1 font-weight-bold indigo--text">Contact person details</p>
                        <v-container fluid>
                            <v-row>
                              <v-col cols="12" sm="6" md="3">
                                  <v-text-field
                                      outlined
                                      v-model="name"
                                      :rules="[v => (!!v && v.length > 3) || 'Item is required at least 3 characters', v => /^[_A-z]*((-|\s)*[_A-z])*$/.test(v) || 'Name Must be letters only with no spaces']"
                                      label="Full Name"
                                      required

                                  ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                  <!-- <v-text-field
                                      outlined
                                      v-model="phone"
                                      :rules="phoneRules"
                                      class="remove-controls"
                                      label="Phone"
                                      type="number"
                                      required
                                      autocomplete="false"

                                  ></v-text-field> -->
                                  <phoneInput @update="assignPhone" />
                              </v-col>
                              <v-col cols="12" sm="12" md="5">
                                  <v-text-field
                                      outlined
                                      v-model="email"
                                      :rules="emailRules"
                                      label="E-mail"
                                      required

                                  ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row v-for="n in passengersNum" :key="n">
                                <v-col cols="12" md="2" class="py-0 my-0">
                                    <p class="body-1 indigo--text">
                                      passenger {{n}} details, {{adultsNum >= n ? 'Adult' : (childrenNum >= ( n - adultsNum) ? 'Child' : (infantsNum >= (n - (adultsNum + childrenNum)) ? 'Infant' : null))}}
                                    </p>
                                </v-col>
                                <v-col cols="12" :sm="adultsNum >= n ? 6 : 4" md="2" class="py-0 my-0">
                                  <v-select
                                    v-model="passengerGender[n-1]"
                                    :items="['Male', 'Female']"
                                    label="Gender"
                                    outlined
                                    prepend-inner-icon="mdi-gender-male-female"
                                    required
                                    class="pa-0"
                                    height="56px"

                                    >
                                      <template v-slot:selection="{ item }">
                                        <span class="primary--text caption">{{item}}</span>
                                      </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2" v-if="adultsNum >= n" class="my-0 py-0">
                                    <v-combobox
                                      v-model="passengerTitle[n-1]"
                                      :items="['Mr', 'Mrs', 'Ms', 'Miss']"
                                      :search-input.sync="search[n-1]"
                                      hide-selected
                                      hint="Add title and press enter to append it"
                                      label="Title"
                                      outlined
                                      prepend-inner-icon="mdi-card-account-details"
                                      :rules="requiredRule"
                                      class="pa-0"
                                      height="56px"

                                    >
                                      <template v-slot:no-data>
                                        <v-list-item>
                                          <v-list-item-content>
                                            <v-list-item-title>
                                              No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                                            </v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="12" :sm="adultsNum >= n ? 8 : 8" :md="adultsNum >= n ? 4 : 6" class="my-0 py-0">
                                  <v-row>
                                    <v-col cols="12" sm="6">
                                      <v-text-field
                                      outlined
                                      prepend-inner-icon="mdi-account"
                                      v-model="passengerFirstName[n-1]"
                                      :rules="nameRules"
                                      label="First name"
                                      required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                      <v-text-field
                                      outlined
                                      v-model="passengerLastName[n-1]"
                                      prepend-inner-icon="mdi-account"
                                      :rules="nameRules"
                                      label="Last name"
                                      required
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" class="my-0 py-0">
                                  <div :class="(validFormBirthday === false && dateOfBirth[n - 1] === undefined) ? 'error-range-input' : 'picker-cont'">
                                    <v-icon :color="(validFormBirthday === false && dateOfBirth[n - 1] === undefined) ? 'error' : '#757575'">mdi-calendar</v-icon>
                                    <date-range-picker
                                    class="range-input"
                                    ref="picker"
                                    opens="left"
                                    show-dropdowns
                                    :ranges="false"
                                    single-date-picker
                                    :locale-data="{
                                      direction: 'ltr',
                                      format: 'mm/dd/yyyy',
                                      separator: ' - ',
                                      applyLabel: 'Apply',
                                      cancelLabel: 'Cancel',
                                      weekLabel: 'W',
                                      customRangeLabel: 'Custom Range',
                                      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                                      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                      firstDay: 1
                                    }"
                                    :maxDate="adultsNum >= n ? adultsMaxDate : ((childrenNum >= (n - adultsNum)) ? childrenMaxDate :  new Date().toISOString().substr(0, 10))"
                                    :minDate="adultsNum >= n ? '1930-01-01' : ((childrenNum >= (n - adultsNum)) ? childrenMinDate : infantsMinDate)"
                                    :autoApply="true"
                                    v-model="range[n-1]"
                                    @toggle="birthdayIndex = n-1; validFormBirthday = false"
                                    @select="setBirthDates"
                                    >
                                      <template v-slot:input="picker" style="min-width: 350px;">
                                        <span class="body-2 text-no-wrap">{{ picker.startDate ? picker.startDate.toString().substring(4, 15) : 'Birthday' }}</span>
                                      </template>
                                    </date-range-picker>
                                  </div>
                                  <p style="display: block;" v-if="(validFormBirthday === false && dateOfBirth[n - 1] === undefined)" class="caption error--text">Please fill this field</p>
                                </v-col>
                                <v-col cols="12" sm="4" md="4" class="my-0 py-0">
                                    <v-text-field
                                        v-model="passNum[n-1]"
                                        @focus="addValue(n-1)"
                                        label="Passport number"
                                        prepend-inner-icon="mdi-passport"
                                        outlined
                                        color="#757575"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4" lg="4" class="my-0 py-0">
                                  <div class="picker-cont">
                                    <v-icon color="#757575">mdi-calendar</v-icon>
                                    <date-range-picker
                                    class="range-input pass-range-input"
                                    ref="passportPicker"
                                    opens="center"
                                    :ranges="false"
                                    single-date-picker
                                    :locale-data="{
                                      direction: 'ltr',
                                      format: 'mm/dd/yyyy',
                                      separator: ' - ',
                                      applyLabel: 'Apply',
                                      cancelLabel: 'Cancel',
                                      weekLabel: 'W',
                                      customRangeLabel: 'Custom Range',
                                      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                                      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                      firstDay: 1
                                    }"
                                    show-dropdowns
                                    :minDate="minExpireDate"
                                    :autoApply="true"
                                    v-model="passportRange[n-1]"
                                    @toggle="passportIndex = n-1; expire(n-1);"
                                    @select="setPassport"
                                    >
                                      <template v-slot:input="passportPicker" style="min-width: 350px;">
                                        <span class="body-2 text-no-wrap">{{ passportPicker.startDate ? passportPicker.startDate.toString().substring(4, 15) : 'Passport Expire Date' }}</span>
                                      </template>
                                    </date-range-picker>
                                  </div>
                                  <!-- <p style="display: block;" v-if="(validFormPassport === false && passExpireDate[n - 1] === undefined)" class="caption error--text">Please fill this field</p> -->
                                </v-col>
                                <v-col cols="12" sm="4" md="4" lg="4" class="my-0 py-0">
                                    <v-autocomplete
                                    v-model="issueCountry[n-1]"
                                    :items="countries"
                                    item-text="name"
                                    item-value="code"
                                    placeholder="Issuing Country"
                                    name="issue-country-for-passports"
                                    outlined
                                    prepend-inner-icon="mdi-flag"
                                    hide-no-data

                                    autocomplete="off"
                                    :menu-props="{ auto: true, maxWidth: 200, overflowY: false }"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12"  class="mb-5 py-0">
                                  <v-expansion-panels elevation="0">
                                    <v-expansion-panel elevation="0" @click="getServiceList">
                                      <v-expansion-panel-header>
                                         Special Services
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <!-- <v-row>
                                         <v-col cols="4">
                                           <v-btn color="indigo" class="white--text" @click="seatMapDialog=true">Choose Your Seat</v-btn>
                                           <v-dialog v-model="seatMapDialog">
                                            <v-card>
                                              <v-card-text>
                                                <v-row class="d-flex flex-column align-center justify-center mt-5">
                                                  <h3 class="text-uppercase indigo--text">Choose your seat</h3>
                                                  <p class="caption">Select a seat (or skip to let us assign one)</p>
                                                  <v-tabs
                                                    v-model="tab"
                                                    background-color="transparent"
                                                    color="indigo"
                                                    grow
                                                  >
                                                     <v-row v-for="segment in flight.flightSegments" :key="segment">
                                                      <v-tab
                                                      v-for="item in segment.Segments"
                                                      :key="item"
                                                      @click="getSeatMap(item.externalRef)"
                                                    >
                                                    <v-span class="black--text">{{ item.OriginLocationCode }}-{{item.DestinationLocationCode }} </v-span> <v-chip class="font-weight-bold" color="idingo">  {{item.MarketingAirlineCode }}{{ item.FlightNumber }}</v-chip>
                                                  </v-tab>
                                                </v-row>
                                                </v-tabs>
                      </v-row>
                      <v-container v-if="seats" class="mt-5">
                        <v-row class="mb-n6" align="center">
                          <v-col cols="1"></v-col>
                          <v-col v-for="(colWidth,start) in layout" :key="colWidth" :cols="colWidth">
                            <div class="d-flex mb-n7">
                              <p
                                class="font-weight-bold black--text mr-8"
                                v-for="name in reshapeSeatNumber(start)"
                                :key="name"
                              >
                                {{ name }}
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row v-for="(row, rowIndex) in seats" :key="rowIndex" align="center" >
                          <v-col cols="1"><p class="font-weight-bold black--text"> {{ row.rowNumber }}</p></v-col>
                          <v-col
                            v-for="(segmentSize, segIndex) in layout"
                            :key="segIndex"
                            :cols="segmentSize"
                          >
                            <v-menu
                              v-for="(seat,index) in reshapeSeatMap(row.seats, segIndex)"
                              :key="index"
                              open-on-hover
                              top
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-if="seat"
                                  small
                                  fab
                                  :color="seat.status === 'available' ? 'blue' : 'grey'"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="white">{{ seat.status === 'available' ? 'mdi-seat' : 'mdi-cancel' }}</v-icon>
                                </v-btn>
                                <p v-else fab></p>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-icon>mdi-ticket-confirmation</v-icon>
                                  Seat:{{ seat? seat.seatNumber : ''}}</v-list-item>
                                <v-list-item>
                                  <v-icon>mdi-cash</v-icon>
                                  Price:{{ seat ? seat?.price : '' }}</v-list-item>
                                <v-list-item>
                                  <v-icon>mdi-seat</v-icon>
                                  Type:{{ seat ? seat.type : ''}}</v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                      </v-row>
                      </v-container>
                                              </v-card-text>
                                            </v-card>
                                           </v-dialog>
                                         </v-col>
                                        </v-row> -->
                                        <v-row>
                                          <!-- <v-col cols="12" sm="12" md="4">
                                            <v-text-field
                                              outlined
                                              v-model="travellerNumber[n-1]"
                                               label="Known Traveller Number"
                                            >
                                              <template v-slot:append>
                                                <v-badge
                                                  :value="hover"
                                                  content="if you are a member of a trusted traveler such as a TSA Precheck, Global entry, NEXUS or SENTRI, enter your number here"
                                                  bottom
                                                  transition="slide-y-transition"
                                                >
                                                <v-hover v-model="hover">
                                                  <v-icon
                                                    color="grey lighten-1"
                                                  >
                                                   mdi-information-outline
                                                  </v-icon>
                                                </v-hover>
                                                </v-badge>
                                              </template>
                                          </v-text-field>
                                          </v-col> -->
                                          <!-- <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                              outlined
                                              v-model="tsaRedress[n-1]"
                                               label="TSA Redress"
                                            >
                                              <template v-slot:append>
                                                <v-badge
                                                  :value="hovertsa"
                                                  content="This is a unique number of the deparment of homeland security(DHS) assigns to a passenger to promote resolution with previous watch list alerts"
                                                  bottom
                                                  transition="slide-y-transition"
                                                  style="z-index: 55;"
                                                >
                                                <v-hover v-model="hovertsa">
                                                  <v-icon
                                                    color="grey lighten-1"
                                                  >
                                                   mdi-information-outline
                                                  </v-icon>
                                                </v-hover>
                                                </v-badge>
                                              </template>
                                          </v-text-field>
                                          </v-col>
                                           <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                              outlined
                                              v-model="frequentFlayercode[n-1]"
                                               label="Frequent Flayer"
                                            >
                                              <template v-slot:prepend-inner>
                                                <v-img width="55" style="margin-top: -4px;" :src="flightCard[0].marketingAirlines[0].airlineLogo"/>
                                              </template>
                                          </v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="my-0">
                                          </v-col> -->
                                          <v-col cols="12" md="4">
                                            <v-autocomplete
                                              v-model="serviceCode[n-1]"
                                              :items="services"
                                              multiple
                                              item-text="name"
                                              return-object
                                              outlined
                                              label="choose your prefered services"
                                            >
                                              <template v-slot:item="data">
                                                <v-list-item-content>
                                                  <v-list-item-title >{{ data.item.name }}</v-list-item-title>
                                                  <v-list-item-subtitle>{{ data.item.description }}</v-list-item-subtitle>
                                                  <v-list-item-subtitle style="margin: 0 !important;">
                                                    <v-chip
                                                    :color="data.item.chargeable ? 'red' : 'green'"
                                                    class="ml-2 white--text"
                                                  >
                                                    {{ data.item.chargeable ? 'Chargeable' : 'Free' }}
                                                   </v-chip>
                                                  </v-list-item-subtitle>
                                                 </v-list-item-content>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                          <v-col cols="12" md="4">
                                            <v-autocomplete
                                              v-model="segmentCodes[n-1]"
                                              :items="getSegments"
                                              item-value="externalRef"
                                              outlined
                                              multiple
                                              label="choose your segment"
                                            >
                                            <template v-slot:selection="data">
                                              <v-chip>{{ data.item.OriginLocationCode }}-{{ data.item.DestinationLocationCode }}</v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-list-item-content>
                                                  <v-list-item-title >{{ data.item.OriginLocationCode }}-{{ data.item.DestinationLocationCode }}</v-list-item-title>
                                                  <v-list-item-subtitle >{{ data.item.MarketingAirlineCode }}-{{ data.item.FlightNumber }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                            </v-autocomplete>
                                          </v-col>
                                          <v-col cols="12" md="4">
                                            <v-btn
                                              block
                                              color="indigo"
                                              class="white--text"
                                              style="height: 54px;"
                                              @click="getOffers(n-1)"
                                              :loading="offersLoading"
                                              :disabled="!segmentCodes.length && !serviceCode.length"
                                            >Get prices</v-btn>
                                          </v-col>
                                          <v-dialog max-width="600" v-model="offerDialog" persistent >
                                            <v-card class="pa-5">
                                              <v-card-title>Offers for Your Services</v-card-title>
                                              <v-card-text>
                                                <v-row>
                                                  <v-col
                                                    cols="12"
                                                  >
                                                    <v-checkbox
                                                     v-for="(offer,i) in offeredServices"
                                                     :key="i"
                                                     :value="offer"
                                                      v-model="offerItemId"
                                                      :label="`${offer.name} is for ${offer.price.price} ${offer.price.currency} for Segments: ${getOfferSements(offer.segmentsRefs)}`"
                                                      color="indigo"
                                                      hide-details
                                                    >
                                                  </v-checkbox>
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-actions>
                                                <v-spacer/>
                                                <v-card-actions>
                                                  <v-btn color="indigo" class="white--text" @click="confirmOffers(n-1)">Confirm</v-btn>
                                                </v-card-actions>
                                              </v-card-actions>
                                            </v-card>
                                          </v-dialog>
                                        </v-row>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-col>
                                <v-col cols="12" v-if="n < passengersNum">
                                  <v-divider class="my-3"></v-divider>
                                </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-row>
                    </div>
                    <div slot="page3">
                      <bookinData type="flights" :items="travellersData" />
                      <v-divider></v-divider>
                      <v-divider></v-divider>
                      <v-row>
                          <v-col cols="12">
                              <v-row justify="space-between" align="end">
                                  <v-col cols="12">
                                    <v-card outlined class="elevation-0 pa-5">
                                      <v-card-title class="primary--text font-weight-bold">Pricing summary</v-card-title>
                                      <v-card-text>
                                        <p v-for="(item, i) in flight.pricingInfo.breakDowns" :key="i" class="body-1 primary--text mb-0">
                                          {{item.passengerQuantity}}
                                          <template v-for="type in types">
                                            <span :key="type.code" v-if="type.code === item.passengerType">{{type.label}}</span>
                                          </template>(s) basic fare <strong>{{flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode}}{{item.baseFare}}</strong> with <strong>{{flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode}}{{item.taxes}}</strong> taxes  for person ><strong>Total {{flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode}}{{item.totalFare}}</strong>
                                        </p>
                                      </v-card-text>
                                    </v-card>
                                  </v-col>
                                  <v-col cols="6">
                                      <p class="body-1 font-weight-bold primary--text">Total</p>
                                      <p class="body-2 font-weight-regular grey--text text-wrap">
                                          By clicking Confirm & Book button you agree with terms and conditionals and money back gurantee. Thank you for trusting our service.
                                      </p>
                                  </v-col>
                                  <v-col cols="6">
                                      <p class="display-1 font-weight-bold primary--text text-right">{{ flight.pricingInfo.TotalFare_CurrencyCode === 'USD' ? '$' : flight.pricingInfo.TotalFare_CurrencyCode }} {{flight.pricingInfo.newFare > 0 ? flight.pricingInfo.newFare : flight.pricingInfo.TotalFare}}</p>
                                  </v-col>
                              </v-row>
                          </v-col>
                      </v-row>
                      <v-card flat style="height: 220px !important;" class="mt-5">
                        <v-tabs color="indigo" grow v-model="tab">
                          <v-tab  @click="getTabValue('reserve')">Reserve Without Payment</v-tab>
                          <v-tab @click="getTabValue('pay')">Pay & reserve</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" >
                         <v-tab-item>
                           <v-card flat class="pa-3">
                             <p class="mt-3 ml-3 font-weight-bold">Hold your reservation. You can pay later.</p>
                             <v-alert
                               type="info"
                              >
                              Please note: Reservations without payment include free services only.
                              </v-alert>
                           </v-card>
                         </v-tab-item>
                         <v-tab-item>
                          <v-form v-model="valid2" ref="form2">
                          <!-- <address-card class="mb-5" /> -->
                          <v-card outlined class="my-5">
                            <v-card-title>Payment</v-card-title>
                            <v-card-text>
                              <v-radio-group v-model="paymentMethod">
                                <v-radio value="cash" label="cash"></v-radio>
                                <!-- <v-radio value="credit" label="credit"></v-radio> -->
                              </v-radio-group>
                            </v-card-text>
                          </v-card>
                          <!-- <credit v-if="paymentMethod === 'credit'" @card="setCardData" @expire="setCardExpiry" @cvv="setCVV" /> -->
                        </v-form>
                         </v-tab-item>
                        </v-tabs-items>
                      </v-card>
                    </div>
                    <div v-if="$store.state.paymentTab === 'reserve'" slot="page4">
                      <div v-if="errors.length">
                        <p class="error--text font-weight-bold text-center"> An Error Occurred</p>
                        <h3 class="body-1 font-weight-bold primary--text mt-5">Your Booking Reference is {{pnr}}</h3>
                         <p v-for="warn in warning" :key="warn" class="body-1 font-weight-bold primary--text mt-5">
                        {{ warn }}
                      </p>
                      </div>
                      <div v-else>
                        <h3 class="display-1 font-weight-thin primary--text">Your flight was booked successfully, we will send you an email with more details.</h3>
                      <h3 class="body-1 font-weight-bold primary--text mt-5">Your Booking Reference is {{pnr}}</h3>
                      <h3 class="body-1 font-weight-bold primary--text">Total price is {{ currency === 'USD' ? '$' : currency }}{{totalPrice}}</h3>
                      </div>
                    </div>
                    <div v-else slot="page4">
                      <v-card flat class="">
                        <v-card-title class="w-100 d-flex justify-center">Review Your Booking</v-card-title>
                        <v-card-subtitle class="text-center">Please confirm your flight details and total price before completing the booking</v-card-subtitle>
                          <h3 class="body-1 font-weight-bold primary--text mt-5">Your Booking Reference is {{pnr}}</h3>
                          <h3 class="body-1 font-weight-bold primary--text">Total price is {{ currency === 'USD' ? '$' : currency }}{{totalPrice}}</h3>
                          <p class=mt-2>💡 This price includes all selected chargeable services.</p>
                          <h3 v-if="offerExpireDate" class="body-1 font-weight-bold primary--text">Offer Expiration Date: {{ offerExpireDate }}</h3>
                      </v-card>
                    </div>
                    <div v-if="tab !== 'reserve'" slot="page5">
                      <h3 class="display-1 font-weight-thin primary--text">Your flight was booked successfully, we will send you an email with more details.</h3>
                      <h3 class="body-1 font-weight-bold primary--text mt-5">Your Booking Reference is {{pnr}}</h3>
                      <h3 class="body-1 font-weight-bold primary--text">Total price is {{ currency === 'USD' ? '$' : currency }}{{totalPrice}}</h3>
                    </div>
                  </vue-good-wizard>
                </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <p class="body-1 primary--text">This flight is not available, please seach again.</p>
              </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { getFlight, getAirports, issueTK, headersNoAuth, createPNR, intentTK, getSeats, getServices, getOffers } from '../links'
import { countries } from '../contants'
import flightCard from '../components/flightCard.vue'
import bookinData from '../components/bookingDataTable'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import phoneInput from '../components/mobile.vue'
// import credit from '../components/credit'
// import addressCard from '../components/address info.vue'

export default {
  title: 'Fare33-Book',
  components: {
    flightCard,
    bookinData,
    DateRangePicker,
    phoneInput
    // credit
    // addressCard
  },
  data () {
    return {
      range: [],
      hover: false,
      hovertsa: false,
      paymentMethod: 'cash',
      passportRange: [],
      birthdayIndex: null,
      passportIndex: null,
      seatMapDialog: false,
      steps: [
        {
          label: 'Review',
          slot: 'page1'
        },
        {
          label: 'Travellers',
          slot: 'page2'
        },
        {
          label: 'Payment & Booking',
          slot: 'page3'
        },
        {
          label: 'Done',
          slot: 'page4'
        }
      ],
      show: false,
      showOverlay: false,
      interval: null,
      nextLabel: 'Continue',
      menu: false,
      menu1: [],
      menu2: [],
      valid1: true,
      valid2: true,
      validFormBirthday: true,
      validFormPassport: true,
      loading: false,
      loaded: true,
      snackbar: false,
      color: '',
      text: '',
      flight: null,
      flightResults: null,
      departures: [],
      arrivals: [],
      departDates: [],
      arriveDate: null,
      passengers: {},
      name: '',
      nameRules: [v => (!!v && v.length > 1) || 'Item is required at least 2 characters',
        v => /^[A-Za-z][A-Za-z]*$/.test(v) || 'Name Must be letters only with no spaces'
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Phone is required',
        v => (!isNaN(v)) || 'Phone must be only numbers'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(v) || 'E-mail must be valid'
      ],
      zipRules: [
        v => !!v || 'Zip code is required',
        v => (!isNaN(v)) || 'Zip code must be only numbers'
      ],
      zip: '',
      requiredRule: [
        v => !!v || 'Field is required'
      ],
      passRules: [
        v => !!v || 'Passport number is required',
        v => v.length <= 15 || 'Maximum number of characters is 15'
      ],
      // line: '',
      address: '',
      cardExpireDate: '',
      cardNum: '',
      cardRules: [
        v => !!v || 'Card number is required',
        v => (!isNaN(v)) || 'Card number must be only numbers',
        v => v.length === 16 || 'Card number must be 16 characters'
      ],
      cards: [
        { label: 'Visa', code: 'VI' },
        { label: 'Master Card', code: 'CA' },
        { label: 'American Express', code: 'AX' },
        { label: 'Discover', code: 'DS' },
        { label: 'Diners Club', code: 'DN' }
      ],
      cardCode: '',
      types: [
        { label: 'Adult', code: 'ADT' },
        { label: 'Child', code: 'CHD' },
        { label: 'Infant', code: 'INF' }
      ],
      passengerType: [],
      passengerTitle: [],
      passengerGender: [],
      search: [],
      passengerFirstName: [],
      passengerLastName: [],
      passengerServices: [],
      dateOfBirth: [],
      dateOfBirthText: [],
      passExpireDate: [],
      passExpireDateText: [],
      minExpireDate: '',
      passNum: [''],
      issueCountry: [],
      goNext: true,
      pnr: '',
      totalPrice: '',
      currency: '',
      currentPage: 0,
      travellersData: [],
      // travellerNumber: [],
      // tsaRedress: [],
      // frequentFlayercode: [],
      seatType: [],
      specialMeal: [],
      specialService: [],
      seatTypesArray: [],
      specialMealsArray: [],
      specialRequestsArray: [],
      seats: [],
      layout: [],
      seatNames: [],
      seatDialog: false,
      warning: [],
      errors: [],
      services: [],
      serviceCode: [[]],
      segmentCodes: [[]],
      offersLoading: false,
      offerDialog: false,
      offeredServices: [],
      offerItemId: [],
      tab: 'reserve',
      offerExpireDate: null,
      lastDatePurse: null
    }
  },
  computed: {
    flightCard () {
      const flights = []
      flights.push(this.flight)
      return flights
    },
    countries () {
      return countries
    },
    adultsNum () {
      return Number(this.passengers.adults)
    },
    childrenNum () {
      return Number(this.passengers.children)
    },
    infantsNum () {
      return Number(this.passengers.infants)
    },
    passengersNum () {
      return Number(this.passengers.adults) + Number(this.passengers.children) + Number(this.passengers.infants)
    },

    // compute passengers valid birth range
    adultsMaxDate () {
      const today = new Date()
      const max = `${today.getFullYear() - 12}-${today.getMonth() + 1}-${today.getDate() - 1}`
      return max
    },
    childrenMaxDate () {
      const today = new Date()
      const max = `${today.getFullYear() - 2}-${today.getMonth() + 1}-${today.getDate() - 1}`
      return max
    },
    childrenMinDate () {
      const today = new Date()
      const min = `${today.getFullYear() - 12}-${today.getMonth() + 1}-${today.getDate() - 1}`
      return min
    },
    infantsMinDate () {
      const today = new Date()
      const min = `${today.getFullYear() - 2}-${today.getMonth() + 1}-${today.getDate() - 1}`
      return min
    },
    cardExpireDateText () {
      if (this.cardExpireDate) return this.formatDate(this.cardExpireDate, 0, 'expire')
      else return ''
    },
    getSegments () {
      const arr = []
      this.flight.flightSegments.map(flight => {
        flight.Segments.map(seg => arr.push(seg))
      })
      console.log(arr)
      return arr
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    currentPage (newVal) {
      if (newVal === 1) {
        setTimeout(() => {
          const inputEl = document.getElementById('card-address')
          if (inputEl) {
            document.getElementById('card-address').addEventListener('input', (e) => {
              this.$store.dispatch('setWrittenAddress', e.target.value)
            })
          }
        }, 500)
      }
    }
  },
  methods: {
    assignPhone (phone) {
      this.phone = phone
    },
    setCardData (number, type) {
      this.cardNum = number
      switch (type) {
        case 'visa':
          this.cardCode = 'VI'
          break
        case 'mastercard':
          this.cardCode = 'CA'
          break
        case 'american-express':
          this.cardCode = 'AX'
          break
        case 'discover':
          this.cardCode = 'DS'
          break
        case 'diners-club':
          this.cardCode = 'DN'
          break
        default:
          this.cardCode = type
          break
      }
    },
    setCardExpiry (date) {
      this.cardExpireDate = date
    },
    setCVV (cvv) {
      this.cvv = cvv
    },
    setBirthDates (date) {
      this.dateOfBirth[this.birthdayIndex] = date.startDate.toISOString().substr(0, 10)
    },
    setPassport (date) {
      this.passExpireDate[this.passportIndex] = date.startDate.toISOString().substr(0, 10)
    },
    formatDate (date, i, type) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const newDate = `${day} ${months[month - 1]} ${year}`
      if (day) type === 'passport' ? this.passExpireDateText[i] = newDate : this.dateOfBirthText[i] = newDate
      else return `${months[month - 1]} ${year}`
    },
    classType () {
      let type
      switch (this.passengers.classType) {
        case 'Y':
          type = 'Economy'
          break
        case 'C':
          type = 'Business'
          break
        case 'F':
          type = 'First'
          break
        case 'P':
          type = 'Premium Economy'
          break
        default:
          break
      }
      return type
    },
    addValue (n) {
      this.passNum[n] = ''
    },
    expire (n) {
      const lastFlightSegment = this.flight.flightSegments[this.flight.flightSegments.length - 1]
      const lastArrivalDate = lastFlightSegment.Segments[lastFlightSegment.Segments.length - 1].ArrivalDate
      const today = new Date(lastArrivalDate)
      today.setMonth(today.getMonth() + 6)
      today.setDate(today.getDate() + 1)
      // this.passExpireDate[n] = today.toISOString().substring(0, 10)
      this.minExpireDate = today.toISOString().substring(0, 10)
    },
    getProperDate (n) {
      if (!this.dateOfBirth[n - 1]) {
        if (this.adultsNum >= (n)) {
          this.dateOfBirth[n - 1] = this.adultsMaxDate
        } else if (this.childrenNum >= (n - this.adultsNum)) {
          this.dateOfBirth[n - 1] = this.childrenMaxDate
        } else if (this.infantsNum >= (n - (this.adultsNum + this.childrenNum))) {
          this.dateOfBirth[n - 1] = this.infantsMinDate
        }
      }
    },
    getSeatMap (segment) {
      this.seats = []
      // const body = {
      //   flight_id: this.$store.state.flightId,
      //   segment_ids: segment,
      //   passenger_ref: 'PAX_1'
      // }
      // const header = { headers: headersNoAuth() }
      const arr = []
      arr.push(segment)
      this.$http.get(getSeats, {
        params: {
          flight_id: this.$store.state.flightId,
          segment_ids: arr,
          passenger_ref: 'PAX_1'
        },
        headers: headersNoAuth()
      }).then(response => response.json()).then(response => {
        this.seats = response?.data.seatsMap[0].seatMap
        console.log(this.seats)
        console.log(response?.data.seatsMap[0].seatMap)
        console.log('test', this.flight.flightSegments)
        if (this.seats) {
          this.layout = response?.data.seatsMap[0].layout.split('-').map(item => Number(item))
          console.log('test77', this.layout)
          this.getSeatsNames()
          console.log(this.seatNames)
        }
      })
      // if (this.seats) {
      //   const arr = this.seats[0]
      //   return Math.max(...arr)
      // }
    },
    getSeatsNames () {
      const sum = this.layout.reduce((acc, curr) => {
        return acc + curr
      }, 0)
      let maxArr = null
      for (let i = sum; i > 0; i--) {
        maxArr = this.seats.find(seat => seat.seats.length === i)
        if (maxArr) break // stop as soon as found
      }
      if (maxArr) {
        const arr = maxArr[0].seats.map(seat => seat.column)
        this.seatNames = arr
        console.log('test100', arr)
      } else {
        this.seatNames = []
        console.log('No matching seats found')
      }
    },
    reshapeSeatMap (rowSeats, segIndex) {
      if (segIndex < this.layout.length) {
        const arr = []
        const start = this.layout.slice(0, segIndex).reduce((a, b) => a + b, 0)
        const end = start + this.layout[segIndex]
        const newSeatNumbers = this.seatNames.slice(start, end)
        console.log('test1', newSeatNumbers)
        console.log('test2', rowSeats)
        for (const seatName of newSeatNumbers) {
          let flag = 'not'
          let foundSeat = null
          for (const seat of rowSeats) {
            if (seat.column === seatName) {
              foundSeat = seat
              flag = 'exist'
              break
            } else {
              flag = 'not'
            }
          }
          if (flag === 'exist') arr.push(foundSeat)
          else arr.push(null)
        }
        console.log(arr)
        return arr
      }
    },
    reshapeSeatNumber (start) {
      if (this.seatNames.length) {
        const begin = this.layout.slice(0, start).reduce((a, b) => a + b, 0)
        console.log('test', begin)
        const end = begin + this.layout[start]
        console.log('test2', end)
        console.log(this.seatNames.slice(begin, end))
        return this.seatNames.slice(begin, end)
      }
    },
    // reshapeSeatMap (index, width) {
    //   console.log(index, width)
    //   console.log(this.seats.slice(index, width))
    //   return this.seats.slice(index, width + 1)
    // },
    getServiceList () {
      const header = { headers: headersNoAuth() }
      this.$http.get(getServices(this.$store.state.flightId), header).then(response => {
        this.services = response.body.data.services
        console.log(response.body.data.services)
      }
      )
    },
    getOffers (index) {
      const body = {
        flight_id: this.flight.id,
        segment_ids: this.segmentCodes[index],
        offer_id: this.flight.offerId,
        passenger: {
          pax_id: `PAX_${index + 1}`,
          offer_item_id: this.flight.offerItemIds[0]
        },
        chargeable_services: this.serviceCode[index].filter(code => code.chargeable === true).map(code => code.code),
        free_services: this.serviceCode[index].filter(code => code.chargeable === false).map(code => code.code)
      }
      console.log(this.serviceCode)
      console.log(body)
      const header = { headers: headersNoAuth() }
      this.offersLoading = true
      this.$http.post(getOffers, body, header).then(response => {
        console.log(response)
        if (response.data.status === 200) {
          console.log(response.data)
          this.offerItemId = []
          this.offerDialog = true
          this.offeredServices = response.data.data.services
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.offersLoading = false
      })
    },
    confirmOffers (index) {
      console.log('test1', this.offerItemId)
      let freeOffers = []
      let chargeableOffers = []
      let selectedOffers = {}
      if (this.offerItemId.length) {
        if (this.offerItemId.filter(offer => offer !== null).filter(offer => offer.price.price === 0).length) {
          freeOffers = this.offerItemId.filter(offer => offer && offer.price?.price === 0)
          freeOffers = freeOffers.reduce((acc, offer) => {
            const existing = acc.find(o => o.offer_id === offer.offerId)
            const item = {
              offer_item_id: offer.offerItemId,
              pax_ref_id: offer.passengerRefIds[0],
              quantity: 1
            }

            if (existing) {
              existing.offer_items.push(item)
            } else {
              acc.push({
                offer_id: offer.offerId,
                offer_items: [item]
              })
            }

            return acc
          }, [])
        }
        if (this.offerItemId.filter(offer => offer !== null).filter(offer => offer.price.price !== 0).length) {
          chargeableOffers = this.offerItemId.filter(offer => offer && offer.price?.price !== 0)
          chargeableOffers = chargeableOffers.reduce((acc, offer) => {
            const existing = acc.find(o => o.offer_id === offer.offerId)
            const item = {
              offer_item_id: offer.offerItemId,
              pax_ref_id: offer.passengerRefIds[0],
              quantity: 1
            }

            if (existing) {
              existing.offer_items.push(item)
            } else {
              acc.push({
                offer_id: offer.offerId,
                offer_items: [item]
              })
            }

            return acc
          }, [])
        }
        selectedOffers = {
          freeOffers: freeOffers,
          chargeableOffers: chargeableOffers
        }
        console.log('test2', selectedOffers)
      }
      this.passengerServices[index] = selectedOffers
      this.offerDialog = false
    },
    getTabValue (val) {
      this.tab = val
      this.$store.commit('setPaymentTab', val)
      if (this.tab === 'pay') {
        this.steps.pop()
        this.steps.push(
          {
            label: 'confirm Payment',
            slot: 'page4'
          },
          {
            label: 'Done',
            slot: 'page5'
          }
        )
      } else {
        this.steps = [
          {
            label: 'Review',
            slot: 'page1'
          },
          {
            label: 'Travellers',
            slot: 'page2'
          },
          {
            label: 'Payment & Booking',
            slot: 'page3'
          },
          {
            label: 'Done',
            slot: 'page4'
          }
        ]
      }
    },
    getOfferSements (refs) {
      return refs.map((ref) => this.$store.state.segmentsSummary[ref.split('_')[1] - 1].departureLocationCode + '-' + this.$store.state.segmentsSummary[ref.split('_')[1] - 1].arrivalLocationCode).join(',')
    },
    book () {
      let body = {}
      // if (this.paymentMethod === 'credit') {
      //   body = {
      //     flight_id: this.$store.state.flightId,
      //     search_id: this.$store.state.flightResults.search_id,
      //     contact_person_name: this.name,
      //     contact_phone: this.phone.nationalNumber,
      //     countryIsoCode: this.phone.countryCode,
      //     contact_email: this.email,
      //     zipCode: this.$store.state.zipCode,
      //     address: this.$store.state.writtenAddress,
      //     streetLine: this.streetLine,
      //     city: this.$store.state.writtenCity,
      //     state: this.$store.state.writtenState,
      //     countryISO: this.$store.state.writtenCountry,
      //     creditCardNumber: this.cardNum,
      //     creditCardExpireDate: this.cardExpireDate,
      //     creditCardType: this.cardCode,
      //     passengerDetails: this.travellersData
      //   }
      // } else {
      //   body = {
      //     flight_id: this.$store.state.flightId,
      //     search_id: this.$store.state.flightResults.search_id,
      //     contact_person_name: this.name,
      //     contact_phone: this.phone.nationalNumber,
      //     countryIsoCode: this.phone.countryCode,
      //     contact_email: this.email,
      //     zipCode: this.$store.state.zipCode,
      //     address: this.$store.state.writtenAddress,
      //     streetLine: this.streetLine,
      //     city: this.$store.state.writtenCity,
      //     state: this.$store.state.writtenState,
      //     countryISO: this.$store.state.writtenCountry,
      //     cash: true,
      //     passengerDetails: this.travellersData
      //   }
      // }
      body = {
        flight_id: this.$store.state.flightId,
        search_id: this.$store.state.flightResults.search_id,
        contact_person_name: this.name,
        contact_phone: this.phone.nationalNumber,
        countryIsoCode: this.phone.countryCode,
        contact_email: this.email,
        cash: true,
        // zipCode: this.$store.state.zipCode,
        // address: this.$store.state.writtenAddress,
        // streetLine: this.streetLine,
        // city: this.$store.state.writtenCity,
        // state: this.$store.state.writtenState,
        // countryISO: this.$store.state.writtenCountry,
        // creditCardNumber: this.cardNum,
        // creditCardExpireDate: this.cardExpireDate,
        // creditCardType: this.cardCode,
        passengerDetails: this.travellersData
      }
      const header = { headers: headersNoAuth() }
      this.$http.post(this.$store.state.paymentTab === 'reserve' ? createPNR : intentTK, body, header).then(response => {
        console.log(response.body)
        if (response.body.status === false) {
          this.showOverlay = false
          this.text = response.body.message
          this.color = 'error'
          this.goNext = false
          this.snackbar = true
        } else {
          this.showOverlay = false
          if (response.data.data.errors.length) {
            response.data.data.errors.forEach(error => {
              this.text = error.text
              this.color = 'error'
              this.snackbar = true
            })
          }
          this.errors = response.data.data.errors
          this.warning = response.data.data.warnings
          this.pnr = this.$store.state.paymentTab !== 'reserve' ? response.data.data.pnr : response.data.data.PNR
          this.offerExpireDate = response.data.data?.offerExpirationTimeLimit
          this.lastDatePurse = this.$store.state.paymentTab !== 'reserve' ? response.data.date?.lastDateToPurchase : ''
          this.totalPrice = this.$store.state.paymentTab === 'reserve' ? response.data.data.totalPrice : response.data.data.totalPrice.price
          this.currency = this.$store.state.paymentTab === 'reserve' ? response.data.data.priceCurrency : response.data.data.totalPrice.currency
          if (this.$store.state.paymentTab === 'reserve') {
            this.$store.dispatch('setFlightsTimeOut', false)
            localStorage.setItem('timeOut', false)
            if (this.$store.state.flightsTimeOutFunction) this.$store.dispatch('clearFlightsTimeoutFunction')
            if (this.$store.state.flightsSearchTimeOutFunction) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
            document.querySelector('.wizard__body__actions a[data-v-c21d83ca]').style.display = 'none'
          }
          this.nextLabel = this.$store.state.paymentTab === 'reserve' ? 'Finish' : 'Confirm'
          this.currentPage = 3
          this.$refs.myWizard.goTo(3)
        }
      }, () => {
        this.showOverlay = false
        this.snackbar = true
        this.goNext = false
        this.color = 'error'
        this.text = 'Something went wrong please try again in few minutes'
      })
    },
    confirmBooking () {
      const header = { headers: headersNoAuth() }
      const body = {
        pnr: this.pnr,
        flight_id: this.$store.state.flightId,
        search_id: this.$store.state.flightResults.search_id,
        passenger_last_name: this.passengerLastName[0]
      }
      this.showOverlay = true
      this.$http.post(issueTK, body, header).then(response => {
        console.log(response.body)
        if (response.body.status === false) {
          this.showOverlay = false
          this.text = response.body.message
          this.color = 'error'
          this.goNext = false
          this.snackbar = true
        } else {
          this.showOverlay = false
          if (response.data.data.errors.length) {
            response.data.data.errors.forEach(error => {
              this.text = error.text
              this.color = 'error'
              this.snackbar = true
            })
          }
          this.pnr = response.data.data.pnr
          this.currency = response.data.data.totalPrice.currency
          this.totalPrice = response.data.data.totalPrice.price
          this.$store.dispatch('setFlightsTimeOut', false)
          localStorage.setItem('timeOut', false)
          if (this.$store.state.flightsTimeOutFunction) this.$store.dispatch('clearFlightsTimeoutFunction')
          if (this.$store.state.flightsSearchTimeOutFunction) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
          this.nextLabel = 'finish'
          this.currentPage = 4
          this.$refs.myWizard.goTo(4)
        }
      }, () => {
        this.showOverlay = false
        this.snackbar = true
        this.goNext = false
        this.color = 'error'
        this.text = 'Something went wrong please try again in few minutes'
      })
    },
    prepareTravellersData () {
      this.travellersData = []
      // const frequentflayerCod = this.flightCard[0].marketingAirlines[0].airlineCode
      for (let index = 0; index < this.passengersNum; index++) {
        let type
        let title
        let gender
        if (this.passengerGender[index]) {
          this.passengerGender[index] === 'Male' ? gender = 'M' : gender = 'F'
        }
        if (this.adultsNum >= (index + 1)) {
          type = 'ADT'
          title = this.passengerTitle[index]
          if (this.passengerGender[index] === undefined) {
            if (title === 'Mr') {
              this.passengerGender[index] = 'M'
              gender = 'M'
            } else if (['Mrs', 'Ms', 'Miss'].indexOf(title) !== -1) {
              this.passengerGender[index] = 'F'
              gender = 'F'
            }
          }
        } else if (this.childrenNum >= ((index + 1) - this.adultsNum)) {
          type = 'CHD'
          title = 'CHD'
        } else if (this.infantsNum >= ((index + 1) - (this.adultsNum + this.childrenNum))) {
          type = 'INF'
          title = 'INF'
        }
        this.travellersData.push({
          passengerType: type,
          passengerTitle: title,
          passengerGender: gender,
          passengerFirstName: this.passengerFirstName[index],
          passengerLastName: this.passengerLastName[index],
          selectedOffers: this.passengerServices[index],
          date_of_birth: this.dateOfBirth[index],
          passport_number: this.passNum[index],
          passport_expire_date: this.passExpireDate[index],
          passport_issue_country: this.issueCountry[index],
          // tsaRedress: this.tsaRedress[index] ? this.tsaRedress[index] : null,
          seatSelectType: this.seatType[index] ? this.seatType[index] : null,
          specialService: this.specialService[index] ? this.specialService[index] : null,
          passengerMeal: this.specialMeal[index] ? this.specialMeal[index] : null
          // frequentFlyer: {
          //   number: this.frequentFlayercode[index] ? this.frequentFlayercode[index] : null,
          //   code: this.frequentFlayercode[index] ? frequentflayerCod : null
          // }
        })
      }
      this.travellersData.forEach(obj => {
        for (const key in obj) {
          if (obj[key] === null) {
            delete obj[key]
          }
          // if (obj.frequentFlyer && obj.frequentFlyer.number === null) {
          //   delete obj.frequentFlyer
          // }
        }
      })
    },

    // when next btn is clicked in stepper
    nextClicked (currentPage) {
      try {
        if (currentPage === 1) {
          this.currentPage = 1
          this.$refs.form1.validate()
          this.nextLabel = this.valid1 ? 'Book' : 'Continue'
          if (this.valid1) {
            const fullNames = []
            for (let index = 0; index < this.passengerFirstName.length; index++) {
              fullNames.push(`${this.passengerFirstName[index]} ${this.passengerLastName[index]}`)
            }
            if (new Set(fullNames).size === fullNames.length) {
              if (this.phone.valid) {
                this.snackbar = false
                this.prepareTravellersData()
                return true
              } else {
                this.snackbar = true
                this.color = 'error'
                this.text = 'Please provide a valid phone number'
                return false
              }
            } else {
              this.snackbar = true
              this.color = 'warning'
              this.text = 'Please avoid using similar names for passengers'
              return false
            }
          } else {
            this.snackbar = true
            this.color = 'warning'
            this.text = 'Please fill all fields to continue'
            this.validFormBirthday = false
            this.validFormPassport = false
            return false
          }
        } else if (currentPage === 2) {
          this.currentPage = 2
          // this.$refs.form2.validate()
          this.valid2 = true
          if (this.valid2) {
            this.snackbar = false
            this.showOverlay = true
            this.book()
          } else {
            this.snackbar = true
            this.color = 'warning'
            this.text = 'Please fill all fields to Book'
            return false
          }
        } else if (currentPage === 3 && this.$store.state.paymentTab === 'reserve') {
          this.$store.dispatch('setShowFlightBook', false)
          this.$store.dispatch('setShowFlightResults', false)
          return true
        } else if (currentPage === 3 && this.$store.state.paymentTab !== 'reserve') {
          this.confirmBooking()
        } else if (currentPage === 4) {
          this.$store.dispatch('setShowFlightBook', false)
          this.$store.dispatch('setShowFlightResults', false)
          return true
        } else {
          this.nextLabel = 'Continue'
          return true
        }
      } catch (error) {}
    },
    // when back button is clicked in stepper
    backClicked (currentPage) {
      this.currentPage = currentPage
      if (currentPage === 4) {
        return false
      } else if (currentPage === 2) {
        this.nextLabel = 'Continue'
        return true
      } else return true
    }
  },
  created () {
    // this.$http.get(getspecialRequests, { headers: headersNoAuth() }).then(response => {
    //   const data = response.body.data
    //   console.log('test', data)
    //   this.seatTypesArray = data.filter((item) => item.type === 'seat_type')
    //   this.specialMealsArray = data.filter((item) => item.type === 'special_meal')
    //   this.specialRequestsArray = data.filter((item) => item.type === 'special_service')
    // })
    this.flightResults = this.$store.state.flightResults
    this.$store.state.airports.departureAirports.forEach(item => {
      if (item !== null) {
        this.$http.get(getAirports(item), { headers: headersNoAuth() }).then(response => {
          this.departures.push(response.body[0])
        })
      }
    })
    this.$store.state.airports.arrivalAirports.forEach(item => {
      if (item !== null) {
        this.$http.get(getAirports(item), { headers: headersNoAuth() }).then(response => {
          this.arrivals.push(response.body[0])
        })
      }
    })
    this.$store.state.flightDates.departureDates.forEach(item => {
      if (item !== null) {
        this.departDates.push(item)
      }
    })
    this.arriveDate = this.$store.state.flightDates.arrivalDate
    this.passengers = this.$store.state.passengers
    const passengersNum = Number(this.passengers.adults) + Number(this.passengers.children) + Number(this.passengers.infants)
    for (let i = 0; i < passengersNum; i++) {
      this.menu1[i] = false
      this.menu2[i] = false
      this.passNum.push('')
      this.range.push({})
      this.passportRange.push({})
    }
    const id = this.$store.state.flightId
    const search = this.$store.state.flightResults.search_id
    const relatedFlightId = this.$store.state.relatedFlightId
    let query
    if (relatedFlightId) {
      query = getFlight(id, search, relatedFlightId)
    } else {
      query = getFlight(id, search)
    }
    this.$http.get(query, { headers: headersNoAuth() }).then(response => {
      if (response.body.status === true) {
        this.flight = response.body.data
        this.$store.commit('setSegmentsSummary', response.data.data.segmentsSummary)
        this.loaded = false
      } else {
        this.loaded = false
        this.snackbar = true
        this.color = 'error'
        this.text = response.body.message
      }
    }, () => {
      this.loaded = false
      this.snackbar = true
      this.color = 'error'
      this.text = 'Something went wrong'
    })
  }
}
</script>

<style>
  .input-tel.lg .input-tel__input[data-v-e59be3b4], .country-selector.lg .country-selector__input[data-v-46e105de] {
    height: 56px !important;
    border: 1.2px solid #9e9e9e !important;
  }
  .wizard__body__actions a[data-v-c21d83ca] {
    background-color:#3f51b5 !important;
  }
  .wizard__body__actions[data-v-c21d83ca] {
    background-color:white !important;
    border-top: 0.1px solid #e3e3e3 !important;
  }
  .wizard__body[data-v-c21d83ca] {
    margin-top: 30px !important;
    min-height: auto !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .wizard__step.active .wizard__step__indicator[data-v-c21d83ca] {
    background-color:#3f51b5 !important;
  }
  .wizard__step.active:not(:first-child) .wizard__step__line[data-v-c21d83ca] {
    background-color:#3f51b5 !important;
  }
  [v-cloak] { display: none; }
  .remove-controls input[type='number'] {
    -moz-appearance:textfield;
  }
  .remove-controls input::-webkit-outer-spin-button,
  .remove-controls input::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }
  .picker-cont {
    width: 99%;
    height: 56px;
    border-radius: 5px;
    border: 0.5px solid #a6a6a6;
    padding: 10px 15px;
    display: flex;
  }
  .range-input {
    width: 90%;
  }
  .reportrange-text[data-v-267f4ee2] {
    border: none !important;
  }
  .daterangepicker.opensleft[data-v-267f4ee2] {
    transform: translateY(-20%) !important;
  }
  .daterangepicker.openscenter[data-v-267f4ee2] {
    transform: translate(-50%, -35%) !important;
  }
  .error-range-input {
    width: 99%;
    height: 56px;
    border-radius: 5px;
    border: 2px solid red;
    box-sizing: border-box;
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 10px 15px;
    display: flex;
  }
  .address-autocomplete {
    width: 100%;
    height: 56px;
    outline: none;
    border: 0.5px solid #9e9e9e !important;
    border-radius: 5px;
    padding: 0 10px;
    margin-bottom: 30px;
  }
  button.v-expansion-panel-header:hover{
    color: black !important;
  }
</style>
